import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import BrandLogo from "./BrandLogo";

const linkVariants = {
  hover: { x: 5, color: "#00FF87" },
};

const Footer = () => {
  const { t } = useTranslation("common");
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { key: "home", to: "/" },
    { key: "products", to: "/products" },
  ];

  const serviceLinks = [
    { key: "faq", to: "/faq" },
    { key: "terms_of_service", to: "/terms" },
    { key: "privacy_policy", to: "/privacy" },
  ];

  return (
    <footer className="bg-space border-t border-white/5 text-white pt-12 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <Link to="/" className="mb-4 block">
              <BrandLogo className="h-10 w-auto min-w-[200px]" />
            </Link>
            <p className="text-gray-400 text-body-sm">
              {t("footer_description")}
            </p>
          </div>

          <div>
            <h3 className="text-h4 font-semibold mb-4">
              {t("quick_links")}
            </h3>
            <ul className="space-y-2">
              {quickLinks.map(({ key, to }) => (
                <li key={key}>
                  <Link to={to}>
                    <motion.span
                      className="inline-block text-gray-400"
                      variants={linkVariants}
                      whileHover="hover"
                    >
                      {t(key)}
                    </motion.span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-h4 font-semibold mb-4">
              {t("customer_service")}
            </h3>
            <ul className="space-y-2">
              {serviceLinks.map(({ key, to }) => (
                <li key={key}>
                  <Link to={to}>
                    <motion.span
                      className="inline-block text-gray-400"
                      variants={linkVariants}
                      whileHover="hover"
                    >
                      {t(key)}
                    </motion.span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-8 text-center text-gray-500 text-body-sm">
          <p>
            &copy; {currentYear} 港微創 HK MicroLaunch。{" "}
            {t("all_rights_reserved") || "版權所有。"}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
